// export default function (data) {
//   return {
//     colors: [
//       '#7cb5ec',
//       '#90ed7d',
//       '#f7a35c',
//       '#8085e9',
//       '#f15c80',
//       '#e4d354',
//       '#2b908f',
//       '#f45b5b',
//       '#91e8e1'
//     ],
//     chart: {
//       type: 'pie',
//       backgroundColor: 'rgba(0,0,0,0)',
//       options3d: {
//         enabled: true,
//         alpha: 45,
//         beta: 0,
//         depth: 20
//       }
//     },
//     title: {
//       text: ''
//     },
//     accessibility: {
//       point: {
//         valueSuffix: '%'
//       }
//     },
//     tooltip: {
//       pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
//     },
//     plotOptions: {
//       pie: {
//         allowPointSelect: true,
//         cursor: 'pointer',
//         depth: 15,
//         dataLabels: {
//           enabled: true,
//           format: '<b>{point.name}</b><br>{point.percentage:.1f} %',
//           distance: 10,
//           style: {
//             textOutline: 0,
//             color: '#ffffff',
//             fontSize: '8px'
//           }
//         }
//       }
//     },
//     series: [
//       {
//         type: 'pie',
//         name: '机构活动',
//         data: data.dataList.map(item => {
//           return [item.dataSubCodeName, item.dataValue]
//         })
//       }
//     ],
//     credits: {
//       enabled: false
//     }
//   }
// }
export default function (data) {
  return {
    colors: [
      '#7cb5ec',
      '#90ed7d',
      '#f7a35c',
      '#8085e9',
      '#f15c80',
      '#e4d354',
      '#2b908f',
      '#f45b5b',
      '#91e8e1'
    ],
    chart: {
      type: 'pie',
      backgroundColor: 'rgba(0,0,0,0)',
      options3d: {
        enabled: true,
        alpha: 0
      }
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    plotOptions: {
      pie: {
        enabled: true,
        innerSize: 50,
        depth: 20,
        dataLabels: {
          enabled: true,
          // format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          format: '<b>{point.name}',
          distance: 5,
          style: {
            textOutline: 0,
            color: '#ffffff'
          }
        }
      }
    },
    series: [
      {
        name: '',
        data: data.dataList.map(item => {
          return [item.dataSubCodeName, item.dataValue]
        })
      }
    ],
    credits: {
      enabled: false
    }
  }
}

